import { FaHtml5, FaCss3, FaJs, FaNodeJs, FaBootstrap, FaShopify, FaStripe, FaGithub, FaFigma } from "react-icons/fa";
import { SiCsharp, SiAdobexd } from "react-icons/si";
import { TbFileTypeSql } from "react-icons/tb";
import { BiLogoMongodb } from "react-icons/bi";
import { DiJqueryLogo, DiPhotoshop } from "react-icons/di";

export interface Skill {
    display: String,
    component: JSX.Element
}
export type SkillType = {
    [key: string]: Skill;
}

export const SkillList: SkillType = {
    "html": { "display": "HTML", "component": <FaHtml5 /> },
    "css": { "display": "CSS", "component": <FaCss3 /> },
    "js": { "display": "JavaScript", "component": <FaJs /> },
    "nodejs": { "display": "Node.JS", "component": <FaNodeJs /> },
    "c#": { "display": "C#", "component": <SiCsharp /> },
    "sql": { "display": "SQL", "component": <TbFileTypeSql /> },
    "mongodb": { "display": "MongoDB", "component": <BiLogoMongodb /> },
    "jquery": { "display": "jQuery", "component": <DiJqueryLogo /> },
    "bootstrap": { "display": "Bootstrap", "component": <FaBootstrap /> },
    "shopify": { "display": "Shopify", "component": <FaShopify /> },
    "stripe": { "display": "Stripe", "component": <FaStripe /> },
    "github": { "display": "Github", "component": <FaGithub /> },
    "figma": { "display": "Figma", "component": <FaFigma /> },
    "photoshop": { "display": "Photoshop", "component": <DiPhotoshop /> },
    "xd": { "display": "XD", "component": <SiAdobexd /> },
};